import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

const { ui } = constants.colors;

const { mediaQuery: mq } = mediaQueryStyles;

const {
  BreakpointNames: { xs, sm, md },
} = constants.breakpoints;

const neutral700 = ui.neutral[700];
const greyExtraLight700 = ui.neutral[25];

export const challengesWrapper: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  width: "100%",
  gap: "16px",
  background: greyExtraLight700,
  padding: "16px",
  h3: {
    fontSize: "1.5rem",
    lineHeight: "2 rem",
    fontWeight: "bold",
    fontFamily: "Noto Serif",
  },

  [mq.downTo(sm)]: {
    padding: "32px 40px",
  },

  [mq.downTo(md)]: {
    padding: "32px 80px",
  },
};

export const challengesListCss: CSSObject = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(288px, 1fr))",
  alignItems: "center",
  gap: "16px",
  width: "100%",
  justifyContent: "space-evenly",
  marginBottom: "16px",
  [mq.downTo(xs)]: {
    gridTemplateColumns: "repeat(auto-fill, minmax(380px, 1fr))",
    justifyContent: "left",
  },
};

export const challengesListSectionTitleCss: CSSObject = {
  margin: "0",
  color: neutral700,
  fontSize: "20px",
  lineHeight: "120%",
};
